var React = require('react');

function IconReloadbets (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2B2F35","fillRule":"evenodd","d":"M12,6 L12,2 L7,7 L12,12 L12,8 C15.31,8 18,10.69 18,14 C18,17.31 15.31,20 12,20 C8.69,20 6,17.31 6,14 L4,14 C4,18.42 7.58,22 12,22 C16.42,22 20,18.42 20,14 C20,9.58 16.42,6 12,6 L12,6 Z"}));
}

IconReloadbets.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconReloadbets;

IconReloadbets.default = IconReloadbets;
